import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { selectUser } from "../../../features/userSlice";
import renderWeatherIcon from "../../Other/GetWeatherIcon";
import WidgetFrame, { WidgetEmpty } from "./WidgetFrame";

const cap = (s) => (s ? s.charAt(0).toUpperCase() + s.slice(1) : "");

// Map the user's branch label to a weather branch (mirrors HomeWeatherWidget).
const branchForUser = (branch) => {
  switch (branch) {
    case "Corporate":
      return "Granger";
    case "Window/Door - Mishawaka":
      return "Mishawaka";
    case "Mill - Fort Wayne":
      return "Fort Wayne";
    case null:
    case undefined:
      return "Granger";
    default:
      return branch;
  }
};

const WeatherWidget = () => {
  const user = useSelector(selectUser);
  const [weather, setWeather] = useState(null);
  const [failed, setFailed] = useState(false);
  const branch = branchForUser(user?.branch);

  useEffect(() => {
    let cancelled = false;
    fetch(`/api/weather/getWeatherData?branch=${branch}`)
      .then((res) => res.json())
      .then((data) => {
        if (cancelled) return;
        const record = Array.isArray(data) ? data[0] : null;
        if (record?.current) setWeather(record);
        else setFailed(true);
      })
      .catch(() => !cancelled && setFailed(true));
    return () => {
      cancelled = true;
    };
  }, [branch]);

  const current = weather?.current;

  return (
    <WidgetFrame title="Weather" to="/dashboard/weather">
      {current ? (
        <div className="flex items-center gap-2">
          {/* The animated icons carry a lot of built-in padding, so the box
              is sized (and pulled in) to show the artwork at a useful size. */}
          <span className="-my-3 -ml-2 block h-20 w-20 shrink-0 [&>svg]:h-full [&>svg]:w-full">
            {renderWeatherIcon(
              current.weather?.[0]?.main,
              48,
              current.weather?.[0]?.description
            )}
          </span>
          <div className="min-w-0">
            <p className="text-3xl font-semibold leading-none tabular-nums tracking-tight">
              {Math.round(current.temp)}&deg;F
            </p>
            <p className="app-muted mt-1.5 truncate text-sm">
              {cap(weather.branch)} · {cap(current.weather?.[0]?.description)}
            </p>
          </div>
        </div>
      ) : (
        <WidgetEmpty>
          {failed ? "Weather unavailable right now." : "Loading weather…"}
        </WidgetEmpty>
      )}
    </WidgetFrame>
  );
};

export default WeatherWidget;
